// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__309pi","legacyBtn":"MutateMid_legacyBtn__1EQBj"};